import clsx from 'clsx';
import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router';

export type BreadcrumbItem = {
  text: string;
  url?: string | null;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className }) => {
  return (
    <nav aria-label="Breadcrumb" className={clsx('typography-v1-body4', className)}>
      <ol className="flex flex-wrap items-center">
        {items.map((item, index) => (
          <Fragment key={item.text}>
            {index > 0 ? (
              <li aria-hidden className="mx-2 text-v1-background-200">
                /
              </li>
            ) : null}
            <li className="inline-flex items-center">
              {item.url ? (
                <RouterLink
                  to={item.url}
                  className="text-v1-primary-100 no-underline hover:underline"
                >
                  {item.text}
                </RouterLink>
              ) : (
                <span className="text-v1-background-200">{item.text}</span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
